import styled from 'styled-components';

export const StyledVisitSettlementFormTab = styled.div`
   height: 100%;
   overflow: hidden;
`;

StyledVisitSettlementFormTab.displayName = 'StyledVisitSettlementFormTab';
